import { PageShell } from "@/components/marketing/PageShell";

const ENDPOINTS = [
  {
    method: "POST",
    path: "/api/v1/cases",
    desc: "Create a verification case with subject, declared address, household roster, case type, risk tier, and permissible purpose.",
  },
  {
    method: "GET",
    path: "/api/v1/cases/{id}/status",
    desc: "Retrieve the current case status in the lifecycle (Intake → Awaiting Consent → … → Report Issued).",
  },
  {
    method: "GET",
    path: "/api/v1/cases/{id}/report",
    desc: "Fetch the signed assurance report (expiring signed download link) once issued.",
  },
  {
    method: "POST",
    path: "/api/v1/webhooks",
    desc: "Register a webhook endpoint to receive case status-change events.",
  },
];

const method_color = {
  POST: "bg-oath-accent-light text-oath-accent border-blue-200",
  GET: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export default function ApiDocs() {
  return (
    <PageShell eyebrow="— DEVELOPERS —" title="API documentation">
      <p className="mb-8 max-w-2xl text-oath-secondary">
        The ResidenceProof REST API lets approved organizations create cases, poll status,
        and retrieve signed reports programmatically. Authentication uses per-organization
        API keys issued from the console. The reference below is a preview; the live,
        interactive API arrives in Phase 08.
      </p>

      <div className="rounded-3xl border border-gray-300/60 bg-oath-panel/50 p-3">
        <div className="space-y-3">
          {ENDPOINTS.map((e) => (
            <div key={e.path} className="rounded-2xl border border-gray-200 bg-white p-5" data-testid={`endpoint-${e.path.replace(/[^a-z]/gi, "")}`}>
              <div className="flex items-center gap-3">
                <span className={`rounded-md border px-2 py-1 font-mono-label text-[9px] font-semibold ${method_color[e.method]}`}>
                  {e.method}
                </span>
                <code className="font-mono text-sm text-oath-ink">{e.path}</code>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-oath-secondary">{e.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-6 rounded-2xl border border-gray-200 bg-oath-navy p-5">
        <p className="font-mono-label text-[9px] text-white/50">EXAMPLE REQUEST</p>
        <pre className="mt-3 overflow-x-auto font-mono text-[12px] leading-relaxed text-white/85">
{`curl -X POST https://api.residenceproof.com/v1/cases \\
  -H "Authorization: Bearer <ORG_API_KEY>" \\
  -H "Content-Type: application/json" \\
  -d '{
    "subject": { "name": "Jane Doe", "dob": "1988-04-12" },
    "declared_address": "4307 Avenue G, Austin, TX 78751",
    "case_type": "underwriting",
    "risk_tier": "Medium",
    "permissible_purpose": "insurance_underwriting"
  }'`}
        </pre>
      </div>
    </PageShell>
  );
}
